import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ServiceBaseEffect } from './service-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ ServiceBaseEffect ])
  ]
})
export class ServiceBaseModule {

}
